import { takeLatest, call, put, delay, select, takeEvery } from "redux-saga/effects"
import { GET_BILLING_CHARACTER_COUNT, GET_BILLING_USER_LOGIN_DETAILS } from "../types"
import { documentsService } from "../services/documents.services"
import { CONTEXT_TYPE, CLIENT_SIDE_MESSAGES as Messages, clearLocalStorage, reSortArray, searchTermParse } from "../utils"
import axios from "../services/axios"
import axiosClient from "axios"
import { postSavedDateRangeFailed, postSavedDateRangeSuccess } from "../actions/createTimelineActions"
import { setFilterJobId } from "../actions/filterActions"
import moment from "moment"
import { setNotification } from "../actions/notificationActions"
import {
	getCharacterCountFailed,
	getCharacterCountSuccess,
	getUserloginDetailsFailed,
	getUserloginDetailsSuccess,
} from "../actions/billingActions"

function* getBillingCharacterCountSaga(action) {
	try {
		const result = yield call(documentsService?.getBillingCharacterCount, action?.payload)
		if (result?.status === 200 && result?.data?.success === true) {
			yield put(getCharacterCountSuccess(result?.data))
			yield put(
				setNotification({
					data: result?.data?.message,
					severity: "success",
					duration: 5000,
				})
			)
		} else {
			yield put(
				setNotification({
					data: result?.data?.message,
					severity: "error",
					duration: 5000,
				})
			)
			yield put(getCharacterCountFailed(result?.data?.message))
		}
	} catch (error) {
		yield put(getCharacterCountFailed(Messages.SERVER_ERROR))
	}
}

function* getUserloginDetailsSaga(action) {
	try {
		const result = yield call(documentsService?.getBillingUserDetails, action?.payload)
		if (result?.status === 200 && result?.data?.success === true) {
			yield put(getUserloginDetailsSuccess(result?.data))
			yield put(
				setNotification({
					data: result?.data?.message,
					severity: "success",
					duration: 5000,
				})
			)
		} else {
			yield put(
				setNotification({
					data: result?.data?.message,
					severity: "error",
					duration: 5000,
				})
			)
			yield put(getUserloginDetailsFailed(result?.data?.message))
		}
	} catch (error) {
		yield put(getUserloginDetailsFailed(Messages.SERVER_ERROR))
	}
}

export default function* billingSagas() {
	yield takeLatest(GET_BILLING_CHARACTER_COUNT, getBillingCharacterCountSaga)
	yield takeLatest(GET_BILLING_USER_LOGIN_DETAILS, getUserloginDetailsSaga)
}
